import React from 'react'
import PropTypes from 'prop-types'

import TableSplitButton from '~/components/TableSplitButton'
import useDeleteConfirm from '~/components/TableSplitButton/useDeleteConfirm'

function BulkActionButton ({ onCustomersDelete, loading }) {
  const { handleClick } = useDeleteConfirm()

  const options = [
    {
      label: 'Delete',
      'data-cy': 'deleteMenu',
      onMenuClick: () => handleClick(onCustomersDelete)
    },
  ]

  return (
    <TableSplitButton
      options={options}
      name="customer"
      loading={loading}
    />
  )
}

BulkActionButton.propTypes = {
  onCustomersDelete: PropTypes.func.isRequired,
  loading: PropTypes.bool
}

export default BulkActionButton
